import React, {useContext, useState} from "react";
import {Box, Checkbox, NumberField} from "@mbank-design/design-system/components";
import {AdditionalSupportContext} from "./AdditionalSupportContext";

export default function HotelSection() {
    const [checked, setChecked] = useState(false);
    const {showHotel, hotelCount, onHotelCountChange} = useContext(AdditionalSupportContext);

    const onValueChange = (value: string) => {
        onHotelCountChange!(parseInt(value, 10));
    }

    const onCheckedChange = () => {
        if (checked)
            onHotelCountChange!(0);
        else
            onHotelCountChange!(1);

        setChecked(!checked);
    }

    if (showHotel) {
        return (
            <>
                <Checkbox checked={checked} onChange={onCheckedChange} label={"hotel"} />
                {checked ? (
                    <Box maxWidth={300}>
                        <NumberField value={hotelCount} onChange={onValueChange} label={"how many guests?"} isStepperVisible />
                    </Box>
                ) : (<></>)}
            </>
        )
    } else return <></>
    
}